// import { GripVertical } from "lucide-react"
import * as ResizablePrimitive from 'react-resizable-panels';

// A simplified PanelGroup that just spreads props onto the underlying component.
// You can attach your own className or styles if you like.
export function ResizablePanelGroup(props: React.ComponentProps<typeof ResizablePrimitive.PanelGroup>) {
    return <ResizablePrimitive.PanelGroup {...props} />;
}

// A direct re-export of Panel. Attach your own props/styles as needed.
export const ResizablePanel = ResizablePrimitive.Panel;

// A simplified handle, with an optional icon via the "withHandle" prop.
// No default styles; add your own if needed.
export function ResizableHandle({
    withHandle,
    ...props
}: React.ComponentProps<typeof ResizablePrimitive.PanelResizeHandle> & {
    withHandle?: boolean;
}) {
    return (
        <ResizablePrimitive.PanelResizeHandle
            style={{
                display: 'flex',
                alignItems: 'center',
                width: '20px',
                cursor: 'col-resize',
                position: 'relative',
            }}
            {...props}>
            {/* <div
        style={{
          position: "absolute",
          top: '10px',
          bottom: '10px',
          left: "50%",
          width: "0px",
          backgroundColor: "#DDD",
          transform: "translateX(-50%)",
        }}
      /> */}
            {withHandle && (
                <div
                    aria-label="Resize handle"
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        color: '#CCC',
                    }}>
                    {/* <GripVertical /> */}
                    <div
                        style={{
                            width: '4px',
                            height: '32px',
                            borderRadius: '8px',
                            backgroundColor: 'var(--color-background-border)',
                        }}></div>
                </div>
            )}
        </ResizablePrimitive.PanelResizeHandle>
    );
}
